import React from "react";
import "react-awesome-slider/dist/styles.css";
import "../App.css";
import SolutionEcosystem from "../SolutionEcosystem/SolutionEcosystem";
import AgribusinessStack from "../../AgribusinessStack/AgribusinessStack";

// Main component for CBN Deployment for Farmers
export default class GBRCareLandingPage extends React.Component {
  render() {
    return (
      <>
        {/* Banner section  */}
        <AgribusinessStack
          classname="farmUpdateBanner"
          level1="System Integrator"
          level2="Agribusiness"
          level3="Farmers"
        />

        {/* Section representing deployment for farmers */}
        <SolutionEcosystem
          title="CBN Deployment for Farmers"
          type="AB"
          bodycopy="ARN is a type of CBN network where farmers can buy inputs, and LTN is a type of CBN network where farmers can sell the inputs."
        />
      </>
    );
  }
}

